<!-- Only render if form control exists -->
@if (hasFormControl()) {
  <!-- When using provideControl (standalone formControl from item.formControl) -->
  @if (provideControl) {
    <div>
      <fieldset>
        <legend class="fz-12">
          {{ title | translate }}
        </legend>
        <div class="station-types-container">
          @for (stationType of stationTypes; track stationType; let i = $index) {
            <div class="station-type-item">
              <label class="form-radio sm" [for]="item?.id + key + '_' + stationType">
                <input [formControl]="$any(getFormControl())" type="radio" [id]="item?.id + key + '_' + stationType" value="{{ stationType }}" [name]="item?.id + key + '_type'" /><i
                aria-hidden="true"
              ></i>
              <span class="form-control-label">{{ 'STATION.TYPE.' + stationType.toUpperCase() | translate }}</span>
            </label>
          </div>
        }
      </div>
    </fieldset>
  </div>
} @else {
  <div [formGroup]="form">
    <fieldset>
      <legend class="fz-12">
        {{ title | translate }}
      </legend>
      <div class="station-types-container">
        @for (stationType of stationTypes; track stationType; let i = $index) {
          <div class="station-type-item">
            <label class="form-radio sm" [for]="item?.id + key + '_' + stationType">
              <input
                [formControl]="$any(getFormControl())"
                type="radio"
                [id]="item?.id + key + '_' + stationType"
                value="{{ stationType }}"
                [name]="item?.id + key + '_type'"
                /><i aria-hidden="true"></i>
                <span class="form-control-label">{{ 'STATION.TYPE.' + stationType.toUpperCase() | translate }}</span>
              </label>
            </div>
          }
        </div>
      </fieldset>
    </div>
  }
  <!-- When NOT using provideControl (use formGroup context) -->
}
